import React from "react";
import "./Footer.css";
import { strings } from "../../translations/strings";
import FacebookIconLight from "../../assets/icons/FooterFacebookLight.svg";
import MediumIconLight from "../../assets/icons/FooterMediumLight.svg";
import InstagramIconLight from "../../assets/icons/FooterInstagramLight.svg";
import LinkedinIconLight from "../../assets/icons/FooterLinkedinLight.svg";
import FacebookIconDark from "../../assets/icons/FooterFacebookDark.svg";
import MediumIconDark from "../../assets/icons/FooterMediumDark.svg";
import InstagramIconDark from "../../assets/icons/FooterInstagramDark.svg";
import LinkedinIconDark from "../../assets/icons/FooterLinkedinDark.svg";
import LogoDarkMode from "../../assets/icons/NavbarLogoDesktopDark.svg";
import LogoLightMode from "../../assets/icons/NavbarLogoDesktop.svg";

const currentYear = new Date().getFullYear();
const isMobile = window.innerWidth <= 768;

const Footer = ({ data }) => {
  const { colors, isDarkMode } = data;

  const LinkItem = ({ to, title }) => {
    return (
      <p
        className="footer-link-text"
        style={{ color: colors.footerText }}
        onClick={() =>
          window.open(`https://www.scaleup.ba/?section=${to}`, "_blank")
        }
      >
        {title}
      </p>
    );
  };

  return (
    <div
      className="footer-container"
      style={{
        backgroundColor: isMobile
          ? colors.background
          : colors.componentBackground,
      }}
    >
      <div className="footer-content">
        <div>
          <h2
            className="footer-title-one"
            style={{ color: colors.primaryText }}
          >
            {strings.footer_title_one}
          </h2>
          <img
            src={isDarkMode ? LogoDarkMode : LogoLightMode}
            alt="Logo"
            draggable="false"
            className="footer-logo"
          />
          <div className="footer-title-one-texts">
            <p
              className="footer-title-one-text"
              style={{ color: colors.footerText }}
            >
              {strings.footer_scaleup_text_one}
            </p>
            <p
              className="footer-title-one-text"
              style={{ color: colors.footerText }}
            >
              {strings.footer_scaleup_text_two}
            </p>
          </div>
          <div className="footer-icon-row">
            <a
              href={strings.facebook_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={isDarkMode ? FacebookIconDark : FacebookIconLight}
                alt="Facebook"
                className="footer-social-media-icon"
                draggable="false"
                loading="lazy"
              />
            </a>
            <a
              href={strings.linkedin_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={isDarkMode ? LinkedinIconDark : LinkedinIconLight}
                alt="Linkedin"
                className="footer-social-media-icon"
                draggable="false"
                loading="lazy"
              />
            </a>
            <a
              href={strings.instagram_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={isDarkMode ? InstagramIconDark : InstagramIconLight}
                alt="Instagram"
                className="footer-social-media-icon"
                draggable="false"
                loading="lazy"
              />
            </a>
            <a
              href={strings.medium_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={isDarkMode ? MediumIconDark : MediumIconLight}
                alt="Medium"
                className="footer-social-media-icon"
                draggable="false"
                loading="lazy"
              />
            </a>
          </div>
        </div>
        <div>
          <h2 className="footer-title" style={{ color: colors.primaryText }}>
            {strings.footer_title_three}
          </h2>
          <div className="footer-title-one-texts">
            <p
              className="footer-title-one-text"
              style={{ color: colors.footerText }}
            >
              {strings.footer_contact_text_one}
            </p>
            <a
              className="footer-title-one-text"
              href="mailto:info@scaleup.ba?subject=ScaleUp - Info"
              style={{ color: colors.footerText }}
            >
              {strings.footer_contact_text_two}
            </a>
          </div>
        </div>
      </div>
      <div
        className="footer-horizontal-line"
        style={{ backgroundColor: colors.footerLine }}
      />
      <p
        className="footer-copyright"
        style={{ color: colors.footerText }}
      >{`${strings.footer_copyright} ${currentYear}`}</p>
    </div>
  );
};
export default Footer;
